module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_21.757a518e.png";